export const profileDetails = [
  {
    id: "company_details",
    title: "COMPANY DETAILS",
    children: [
      {
        id: "company_name",
        title: "COMPANY NAME",
        type: "text",
        placeholder: "Enter Company Name",
      },
      {
        id: "designation",
        title: "DESIGNATION",
        type: "text",
        placeholder: "Enter Designation",
      },
      {
        id: "emailid",
        title: "EMAIL ID",
        type: "email",
        placeholder: "Enter Email ID",
      },
      {
        id: "website",
        title: "WEBSITE",
        type: "text",
        placeholder: "Enter Website URL",
      },
      {
        id: "address",
        title: "ADDRESS",
        type: "text",
        placeholder: "Enter Address",
      },
      {
        id: "map",
        title: "LOCATION",
        type: "text",
        placeholder: "Enter Location URL",
      },
    ],
  },
  {
    id: "personal_details",
    title: "PERSONAL DETAILS",
    children: [
      {
        id: "image",
        title: "PROFILE",
        type: "file",
        placeholder: "Enter Company Name",
      },
      {
        id: "name",
        title: "NAME",
        type: "text",
        placeholder: "Enter Full Name",
      },
      {
        id: "number",
        title: "CONTACT NUMBER",
        type: "text",
        placeholder: "Enter Mobile Number",
      },
      {
        id: "whatsapp",
        title: "WHATSAPP NUMBER",
        type: "text",
        placeholder: "Enter Website URL",
      },
    ],
  },
  {
    id: "social_details",
    title: "SOCIAL DETAILS",
    children: [
      {
        id: "instagram",
        title: "INSTAGRAM",
        type: "text",
        placeholder: "Enter Instagram Profile URL",
      },
      {
        id: "facebook",
        title: "FACEBOOK",
        type: "text",
        placeholder: "Enter Facebook URL",
      },
      {
        id: "youtube",
        title: "YOUTUBE",
        type: "text",
        placeholder: "Enter Youtube URL",
      },
      {
        id: "twitter",
        title: "TWITTER",
        type: "text",
        placeholder: "Enter Twitter URL",
      },
      {
        id: "linkedin",
        title: "LINKEDIN",
        type: "text",
        placeholder: "Enter Linkedin URL",
      },
    ],
  },
];
